import { Injectable } from '@angular/core'
import { BehaviorSubject } from 'rxjs'

export const savedIls = 'GoLabSavedIls'

@Injectable({
  providedIn: 'root',
})
export class SavedIlsService {
  previousUrl$ = new BehaviorSubject<string | null>(null)

  constructor() {
    const ils = localStorage.getItem(savedIls)
    if (ils) {
      this.previousUrl$.next(ils)
    }
  }

  saveUrl(ilsId: string) {
    localStorage.setItem(savedIls, ilsId)
    this.previousUrl$.next(ilsId)
  }

  clearSavedUrl() {
    localStorage.removeItem(savedIls)
    this.previousUrl$.next(null)
  }
}
